import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

// Import static CSS
import './index.scss'

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js